import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { useMutation } from "@apollo/client";
import { Button } from "@material-ui/core/";

import { setShowUserVerifyStatusModal } from "../../../redux/layout/layoutActions";
import { UPDATE_EMPLOYEE_VERIFY_EMAIL_STATUS } from "../../Pages/Employees/graphQl/mutation";
import { SectionLoader } from "../SectionLoader";

export const EmailVerifiedAlert = () => {
  const dispatch = useDispatch();

  const [error, setError] = useState(null);

  const [isModelOpen, setIsModelOpen] = useState(true);

  const handleModelClose = () => {
    if (isModelOpen) {
      setIsModelOpen(false);
      dispatch(setShowUserVerifyStatusModal(false));
    }
  };

  const intl = useIntl();

  const [
    getEmployeeVerifyEmail,
    {
      loading: emailVerifyLoading,
      data: emailVerifyData,
      error: emailVerifyError,
    },
  ] = useMutation(UPDATE_EMPLOYEE_VERIFY_EMAIL_STATUS);

  useEffect(() => {
    if (emailVerifyLoading) {
      setError(null);
    }

    if (emailVerifyError) {
      setError(emailVerifyError.toString().replace("Error: Error:", ""));
    }

    if (emailVerifyData) {
      setError(null);
      toast.success(intl.formatMessage({ id: "EMAIL.VERIFY.LINK.MESSAGE" }), {
        position: toast.POSITION.TOP_RIGHT,
      });
      handleModelClose();
    }
  }, [emailVerifyLoading, emailVerifyError, emailVerifyData]);

  return (
    <>
      <SectionLoader loader={emailVerifyLoading} />
      <Modal
        show={isModelOpen}
        onHide={handleModelClose}
        aria-labelledby="example-modal-sizes-title-lg"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {error && (
            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
              <div className="alert-text font-weight-bold">{error}</div>
            </div>
          )}

          <p className="mb-5">
            Please verify your email before Becoming a Seller
          </p>
          <div className="modal-footer">
            <Button
              type="button"
              onClick={() => {
                const user = JSON.parse(window.localStorage.getItem("user"));

                getEmployeeVerifyEmail({
                  variables: {
                    email: user?.email,
                  },
                });
              }}
              className="btn btn-primary btn-elevate"
            >
              Resend Verification Email
            </Button>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="button"
            onClick={handleModelClose}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
